<style scoped>
#payroll_header_tab {
	/* This is the background color used on tabs in Omnis, may be a different color on Windows */
	background-color: rgb(252, 252, 252);
}

.new_header {
	background: white;
	margin-bottom: 5px;
	border-radius: 4px;
	box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.edit_new_header:hover {
	background: #DDDDDD;
}

.edit_new_header {
	margin-left: -5px;
	margin-top: -5px;
	margin-bottom: -5px;
	padding-left: 5px;
	padding-top: 5px;
	padding-bottom: 5px;
}

.superaccount {
	background: white;
	margin-top: 5px;
	border-radius: 4px;
	box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.superaccount:hover {
	background: #DDDDDD;
}

</style>

<template>
	<v-container id="payroll_header_tab" fluid>
		<v-alert type="error" v-if="errormsg != ''">
			{{errormsg}}
		</v-alert>

		<div class="new_header blue--text px-6 py-2">
			<div class="edit_new_header" @click.stop="new_payroll_header()">
				Add new payroll header
			</div>
		</div>

		<v-expansion-panels v-model="panels" multiple>
			<v-payroll-header-row
				v-for="payroll_header in payroll_headers"
				:popup_editors="true"
				:key="payroll_header.id"
				:is_expanded="panels.includes(payroll_header.panel_no)"
				:payroll_header="payroll_header"
			/>
		</v-expansion-panels>

		<div class="superaccount px-6 py-2 blue--text" v-if="!loading_superaccounts && superaccounts.length == 0 && show_superannuation" @click.stop="new_superaccount">
			Add super fund
		</div>

		<div class="superaccount px-6 py-2 blue--text"
			v-for="superaccount in superaccounts"
			:key="superaccount.id"
			@click.stop="edit_superaccount(superaccount)"
		>
			Super Fund: {{ superaccount.superfund_name }},
			Member no: {{ superaccount.superfund_account_no }}
		</div>

	</v-container>
</template>

<script>
import moment from 'moment';
import payroll_header_row from "@/components/addressbook/payroll_header/payroll_header_row"

export default {
	components: {
		'v-payroll-header-row': payroll_header_row,
	},
	data() {
		return {
			errormsg: '',
			addressbook_id: 0,
			loading_flavours: false,
			abooktypes: [],
			panels: [ 0 ], // auto expand the first entry
			loading_payroll_headers: false,
			payroll_headers: [],
			loading_superaccounts: false,
			superaccounts: [],
		}
	},
	mounted() {
		this.load(this.$route.params.adbid);
		this.get_abook_flavours(this.$route.params.adbid);

		/* to keep 'document360-widget-iframe' or 'beacon-container' non-showing */
		/* TODO this should be centralised somewhere!!!! */
		const widget_name_str = 'beacon-container';
		const child = document.getElementById(widget_name_str);

		if (child) {
			child.style.display = 'none';
		}	else {
			const body_arr = document.getElementsByTagName('body');
			const target_node = body_arr[0];
			const config = { childList: true};
			let isIframe = false;

			const callback = (mutationsList) => {
				mutationsList.forEach((item) => {
					if (item.type == 'childList') {
						const childNodes = item.target.childNodes;
						childNodes.forEach(c => {
							if (c.id === widget_name_str) {
								isIframe = true;
								const child_new = document.getElementById(widget_name_str);
								child_new.style.display = 'none';
							}
						});
					}
				});
			};

			const observer = new MutationObserver(callback);
			observer.observe(target_node, config);
			if (isIframe) {
				observer.disconnect();
			}
		}
	},
	computed: {
		show_superannuation() {
			let show = false;
			this.abooktypes.forEach(abooktype => {
				if (abooktype == 3) {
					show = true; // employees have this
				} else if (abooktype == 7) {
					show = true; // talent has this
				} else if (abooktype == 12) {
					show = true; // freelancers have this
				}
			});
			return show;
		}
	},
	watch: {
		'$route.params.adbid': function(adbid) {
			this.$nextTick(() => {
				this.load(adbid);
				this.get_abook_flavours(adbid);
			});
		}
	},
	methods: {
		get_abook_flavours(abook_id) {
			let self = this;
			this.loading_flavours = true;
			this.abooktypes = [];

			// load our leave reasons
			axios
				.get("/api/addressbook/" + abook_id , {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						self.abooktypes = json.data.flavours.split(",").map(function(x) {
							return parseInt(x, 10);
						});

						// console.log(self.abooktypes);
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_flavours = false;
				});
		},
		load(abook_id) {
			let self = this; // make sure we can access this inside of our promisses
			this.addressbook_id = abook_id;
			this.loading_payroll_headers = true;
			this.loading_superaccounts = true;

			// load our payroll headers 
			axios
				.get("/api/addressbook/" + abook_id + "/payrollheader", {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						let payroll_headers = json.data;

						payroll_headers.sort(function(a, b) { return moment(a.start_date) < moment(b.start_date) });

						let panel_no = 0
						payroll_headers.forEach(payroll_header => {
							payroll_header.panel_no = panel_no;
							panel_no++;
						});

						self.payroll_headers = payroll_headers;
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_payroll_headers = false;
				});
			
			// load our superannuation record
			axios
				.get("/api/addressbook/" + abook_id + "/superaccount", {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						let superaccounts = json.data;

						self.superaccounts = superaccounts;
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_superaccounts = false;
				});
		},
		new_payroll_header() {
			window.open('/desktop/addressbook/' + this.addressbook_id + '/payroll_header/')
		},
		new_superaccount() {
			window.open('/desktop/addressbook/' + this.addressbook_id + '/superaccount')
		},
		edit_superaccount(account) {
			window.open('/desktop/addressbook/' + this.addressbook_id + '/superaccount/' + account.id)
		},
	},
}	
</script>
